import { graphql } from "gatsby";
import React, { useEffect, useState } from "react";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import Layout from "../components/layout/Layout/Layout";
import { Landing } from "../components/block/Landing/Landing";
import Navigation, {
  NavigationMenu,
} from "../components/layout/Navigation/Navigation";
import { Menu } from "../data/types/Menu";
import { ContentContainer } from "../components/block/ContentContainer/ContentContainer";

const menuIds: Array<Menu> = ["products", "story", "founder"];

const IndexPage: React.FC = () => {
  const [activeId, setActiveId] = useState<Menu>("");
  const [menus, setMenus] = useState<Array<NavigationMenu>>([]);
  const { t } = useTranslation();
  const { language } = useI18next();

  useEffect(() => {
    const key = language === "en-us" ? "" : "home_";
    setMenus(menuIds.map((id) => ({ id, label: t(`${key}menu.${id}`) })));
  }, [language, t]);

  const handleLogoClick = () => {
    setActiveId("");
  };

  return (
    <Layout>
      <Navigation
        navigation={menus}
        activeId={activeId}
        setActiveId={setActiveId}
      />
      <Landing isActive={!activeId} />
      <ContentContainer activeId={activeId} handleLogoClick={handleLogoClick} />
    </Layout>
  );
};
export default IndexPage;

export const query = graphql`
  query ($language: String!) {
    ...TranslationQueryFragment
  }
`;
